/**
 * Robust process polyfill for browser environments.
 * This must be imported at the very top of the app entry point.
 */
(function () {
  'use strict';

  // Early return if process already exists
  if (typeof process !== 'undefined') {
    return;
  }

  // Create process polyfill object
  var processPolyfill = {
    env: {},
    browser: true,
    version: '16.0.0',
    platform: 'browser',
    nextTick: function (fn) {
      if (typeof setImmediate !== 'undefined') {
        setImmediate(fn);
      } else {
        setTimeout(fn, 0);
      }
    },
    cwd: function () { return '/'; },
    exit: function () { },
    argv: [],
    versions: { node: '16.0.0' },
    pid: 1,
    title: 'browser',
    umask: function () { return 0; }
  };

  // Function to set process on any global object
  function setProcess(obj) {
    try {
      if (obj && typeof obj === 'object') {
        try {
          Object.defineProperty(obj, 'process', {
            value: processPolyfill,
            writable: true,
            configurable: true,
            enumerable: false
          });
        } catch (e) {
          obj.process = processPolyfill;
        }
      }
    } catch (e) {
      // Ignore errors
    }
  }

  // Set on all possible global scopes immediately
  if (typeof window !== 'undefined') {
    setProcess(window);
    try {
      window.process = processPolyfill;
    } catch (e) { }
  }
  if (typeof globalThis !== 'undefined') {
    setProcess(globalThis);
    try {
      globalThis.process = processPolyfill;
    } catch (e) { }
  }
  if (typeof global !== 'undefined') {
    setProcess(global);
    try {
      global.process = processPolyfill;
    } catch (e) { }
  }
  if (typeof self !== 'undefined') {
    setProcess(self);
    try {
      self.process = processPolyfill;
    } catch (e) { }
  }

  // Use Function constructor to get the true global scope
  try {
    var getGlobal = new Function('return this');
    var globalObj = getGlobal();
    if (globalObj) {
      setProcess(globalObj);
      try {
        globalObj.process = processPolyfill;
      } catch (e) { }
    }
  } catch (e) {
    // Ignore CSP or other restrictions
  }

  // Set as a direct global variable using Function constructor (for strict mode)
  try {
    var setGlobalProcess = new Function('p', 'process = p');
    setGlobalProcess(processPolyfill);
  } catch (e) {
    // Fallback: ensure it's on window at minimum
    if (typeof window !== 'undefined') {
      try {
        window.process = processPolyfill;
      } catch (e2) { }
    }
  }

  // Define process as a non-configurable property on global scope
  function defineGlobalProcess(globalObj) {
    if (!globalObj) return;
    try {
      Object.defineProperty(globalObj, 'process', {
        value: processPolyfill,
        writable: true,
        configurable: false,
        enumerable: false
      });
    } catch (e) {
      try {
        Object.defineProperty(globalObj, 'process', {
          value: processPolyfill,
          writable: true,
          configurable: true,
          enumerable: false
        });
      } catch (e2) {
        try {
          globalObj.process = processPolyfill;
        } catch (e3) { }
      }
    }
  }

  if (typeof window !== 'undefined') defineGlobalProcess(window);
  if (typeof globalThis !== 'undefined') defineGlobalProcess(globalThis);
  if (typeof global !== 'undefined') defineGlobalProcess(global);
  if (typeof self !== 'undefined') defineGlobalProcess(self);

  // Inject script as well for dynamically loaded scripts
  if (typeof document !== 'undefined' && document.head) {
    try {
      var processScript = document.createElement('script');
      processScript.textContent =
        '(function(){' +
        'if(typeof process==="undefined"){' +
        'var p={env:{},browser:true,version:"16.0.0",platform:"browser",' +
        'nextTick:function(fn){(setImmediate||setTimeout)(fn,0);},' +
        'cwd:function(){return"/";},exit:function(){},argv:[],' +
        'versions:{node:"16.0.0"},pid:1,title:"browser",umask:function(){return 0;}};' +
        'try{Object.defineProperty(this,"process",{value:p,writable:true,configurable:false});}' +
        'catch(e){try{this.process=p}catch(e2){}}' +
        'try{Object.defineProperty(window,"process",{value:p,writable:true,configurable:false});}' +
        'catch(e){try{window.process=p}catch(e2){}}' +
        '}' +
        '})();';
      processScript.setAttribute('data-process-polyfill', 'true');
      if (document.head.firstChild) {
        document.head.insertBefore(processScript, document.head.firstChild);
      } else {
        document.head.appendChild(processScript);
      }
    } catch (e) { }
  }
})();
